import React, { useContext, useState } from "react"
import { ColorPickerStateContext } from "react-aria-components/ColorPicker"
import { DesignColorsSection } from "./design-colors-section"
import type { DesignColors } from "./design-colors-section"
import { useDesignColorsContext } from "./design-colors-provider"
import { toColor } from "./use-color-value"

export type ColorPanelDesignColorsProps = {
  /** Design colors for this panel only, instead of the `DesignColorsProvider`'s */
  designColors?: DesignColors
}

/**
 * The "In this design" colors. Renders nothing when there are none. Place it
 * after `ColorPanel.Picker`.
 */
export function ColorPanelDesignColors({
  designColors
}: ColorPanelDesignColorsProps) {
  const state = useContext(ColorPickerStateContext)
  const getDesignColors = useDesignColorsContext()
  // Collected once, when the panel mounts (the picker opening), not on every
  // render: it can mean walking a whole document
  const [providedDesignColors] = useState(() => getDesignColors?.())
  const design =
    designColors ??
    (providedDesignColors ? { colors: providedDesignColors } : undefined)

  if (!state || !design?.colors.length) return null

  return (
    <div data-slot="color-panel-design-colors" className="flex w-full">
      <DesignColorsSection
        colors={design.colors}
        handleColorSelect={color => {
          design.handleColorSelect?.(color)
          state.setColor(toColor(color))
        }}
      />
    </div>
  )
}

ColorPanelDesignColors.displayName = "ColorPanel.DesignColors"
